export default "__VITE_ASSET__VnwNz7kN__"